export default "__VITE_ASSET__BFthqJkI__"